import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { addAdminsAccess } from "../add-admins-access";
import { removeAdminsAccess } from "../remove-admins-access";
import { translate as t } from "../../../infrastructure/translate/localization";

import "./admins-access-config.scss";

export default class AdminsAccessConfig extends Component {
  constructor(props) {
    super(props);
    const { hrEmails } = this.props;
    this.state = {
      emails: hrEmails,
      inputAdminEmail: "",
      inputAdminPass: "",
    };
  }

  handleAddEmail = () => {
    const { emails, inputAdminEmail, inputAdminPass } = this.state;
    addAdminsAccess(inputAdminEmail, inputAdminPass);
    this.setState({ emails: [...emails, inputAdminEmail] });
  };

  handleRemoveEmail = (email) => {
    const { emails } = this.state;
    this.setState({
      emails: emails.filter((item) => item !== email),
    });
    removeAdminsAccess(email);
  };

  render() {
    const { inputAdminEmail, inputAdminPass, emails } = this.state;
    const { company, adminLogged } = this.props;
    return (
      <div className="sub-section">
        <div className="section-header">
          <div className="cob-btn-group">
            <p className="header-subtitle">
              {t("configuration-section.admin-access")}
            </p>
          </div>
        </div>

        <div className="section-description">
          <p>{t("configuration-section.allow-admin-access-info")}</p>
        </div>

        <div className="add-admin">
          <div className="auto-close cob-btn-group">
            <div className="cob-input-group ">
              <span className="input-label ">
                {t("configuration-section.active-admin")}
              </span>
              <label>
                <ul className="container-input">
                  {emails.map((email) => (
                    <li className="items-tag" key={email}>
                      {email}
                      {adminLogged !== email && (
                        <FontAwesomeIcon
                          icon="trash"
                          className="trash-tag"
                          onClick={() => this.handleRemoveEmail(email)}
                          alt="delete"
                        />
                      )}
                    </li>
                  ))}
                </ul>
              </label>
            </div>
          </div>
          <span>{t("configuration-section.add-admin")}</span>
          <div className="cob-btn-group">
            <div className="cob-input-group ">
              <span className="input-label">{t("common-messages.email")}</span>
              <input
                value={inputAdminEmail}
                type="email"
                placeholder="Email"
                onChange={(e) =>
                  this.setState({ inputAdminEmail: e.target.value })
                }
              />
            </div>
            {!company.forceAdminSSO && (
              <div className="cob-input-group ">
                <span className="input-label">
                  {t("common-messages.password")}
                </span>
                <input
                  value={inputAdminPass}
                  type="password"
                  placeholder={t("common-messages.password-info")}
                  onChange={(e) =>
                    this.setState({ inputAdminPass: e.target.value })
                  }
                />
              </div>
            )}
            <div className="cob-btn-group right-group">
              <button
                type="button"
                className="cob-btn btn-primary"
                disabled={
                  !inputAdminEmail ||
                  (!company.forceAdminSSO && inputAdminPass.length < 8)
                }
                onClick={() => {
                  this.setState({
                    inputAdminEmail: "",
                    inputAdminPass: "",
                  });
                  this.handleAddEmail();
                }}
              >
                {t("actions.add")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AdminsAccessConfig.defaultProps = {};

AdminsAccessConfig.propTypes = {
  company: PropTypes.object.isRequired,
  adminLogged: PropTypes.string.isRequired,
  hrEmails: PropTypes.array.isRequired,
};
